export default "__VITE_ASSET__YUkITP$g__"